import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "allprojects",
  components: {},
  props: [],
  data() {
    return {
      selectedItem: {},
      fields: [
        {
          key: "lvl",
          label: "Level",
          sortable: true
        },
        {
          key: "title",
          label: "Name",
          sortable: true
        },
        {
          key: "points",
          label: "Points"
        },
        {
          key: "users",
          label: "users"
        },
        {
          key: "active",
          label: "Active"
        },
        {
          key: "actions",
          label: "Actions"
        }
      ]
    };
  },
  computed: {
    projects() {
      return this.$store.getters.getProjects.filter(p => p.hasParent === false);
    },
    levels() {
      return this.$store.getters.getLevels;
    },
    profiles() {
      return this.$store.getters.getProfiles;
    }
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Backend" },
      { title: "Content", route: "_projects" },
      { title: "Projects" }
    ]);
  },
  methods: {
    getLevelInfo(l, param) {
      let level = this.levels.find(lev => lev._id == l);
      return level?.[param];
    },
    getProfileInfo(p) {
      let profile = this.profiles.find(profile => profile._id == p);

      return profile?.name;
    },
    deleteItem(id) {
      axios.delete("projects/" + id).then(response => {
        console.log(response);
        this.$store.dispatch("fetchProjects");
      });
    },
    updateActive(i) {
      axios
        .put("projects/" + i._id, { isActive: !i.isActive })
        .then(response => {
          this.$store.dispatch("fetchProjects");
          console.log(response);
        });
    }
  }
};
